module.exports = __webpack_public_path__ + "img/signup.58f6aad1.png";